"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingsAndReviewsSummary = void 0;
var RatingsAndReviewsSummary_1 = require("./RatingsAndReviewsSummary");
Object.defineProperty(exports, "RatingsAndReviewsSummary", { enumerable: true, get: function () { return RatingsAndReviewsSummary_1.RatingsAndReviewsSummary; } });
//# sourceMappingURL=index.js.map